import { render, staticRenderFns } from "./appAssetBreadcrumb.vue?vue&type=template&id=0655d96c&scoped=true"
import script from "./appAssetBreadcrumb.vue?vue&type=script&lang=js"
export * from "./appAssetBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./appAssetBreadcrumb.vue?vue&type=style&index=0&id=0655d96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655d96c",
  null
  
)

export default component.exports